import React from 'react';
import { ListChecks } from 'lucide-react';

/**
 * Компонент с особенностями и элементами бассейна
 */
const PoolFeaturesSection = ({ 
  formData, 
  handleInputChange, 
  handleFeaturesChange,
  errors, 
  specificFeatures 
}) => {
  return (
    <div className="mb-6 bg-cyan-50 dark:bg-cyan-900/20 p-4 rounded-lg border border-cyan-200 dark:border-cyan-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ListChecks className="w-5 h-5 mr-2 text-cyan-500" />
        Особенности бассейна
      </h3>
      
      <div className="space-y-2">
        <p className="text-sm text-cyan-700 dark:text-cyan-300 mb-3">
          Выберите дополнительные элементы вашего бассейна для более точного расчета объема:
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-2">
          {specificFeatures.map((feature) => (
            <label key={feature.id} className="inline-flex items-center">
              <input
                type="checkbox"
                value={feature.id}
                checked={formData.specificFeatures.includes(feature.id)}
                onChange={handleFeaturesChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                {feature.name}
              </span>
            </label>
          ))}
        </div>
        
        <div className="mt-4 pt-4 border-t border-cyan-200 dark:border-cyan-700">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Учитывать в расчетах
            </span>
            <div className="flex space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="includeFeatures"
                  value="true"
                  checked={true}
                  disabled
                  className="form-radio"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  Да
                </span>
              </label>
            </div>
          </div>
          <p className="mt-1 text-xs text-cyan-600 dark:text-cyan-400">
            Выбранные элементы влияют на фактический объем воды и потребность в системах очистки
          </p>
        </div>
      </div>
      
      {/* Таблица со сведениями о элементах */}
      <div className="mt-4 overflow-x-auto rounded-lg border border-cyan-200 dark:border-cyan-700">
        <table className="min-w-full divide-y divide-cyan-200 dark:divide-cyan-700">
          <thead className="bg-cyan-100 dark:bg-cyan-800/30">
            <tr>
              <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-cyan-700 dark:text-cyan-300 uppercase tracking-wider">
                Элемент
              </th>
              <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-cyan-700 dark:text-cyan-300 uppercase tracking-wider">
                Влияние на объем
              </th>
              <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-cyan-700 dark:text-cyan-300 uppercase tracking-wider">
                Рекомендации
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-cyan-200 dark:divide-cyan-700">
            <tr>
              <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                Лестница
              </td>
              <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                Уменьшает на 0.7-1 м³
              </td>
              <td className="px-3 py-2 text-sm text-gray-600 dark:text-gray-400">
                Обычно имеет глубину 0.3-0.4 м, может занимать 15-20% площади
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div className="mt-4">
        <p className="text-xs text-gray-600 dark:text-gray-400">
          * Значения объема для каждого элемента приблизительны и могут варьироваться в зависимости от конкретного 
          проекта и конструкции бассейна. Для более точных расчетов рекомендуется использовать детальные чертежи.
        </p>
      </div>
    </div>
  );
};

export default PoolFeaturesSection;